import { createAsyncThunk } from "@reduxjs/toolkit";
import constantsService from "@/shared/services/api/constants-service";
import { regionService } from "@/shared/services/api/region-service";

export const getCountries = createAsyncThunk(
  "constants/getCountries",
  async (_, thunkAPI) => {
    try {
      const response = await constantsService.getCountries();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
);

export const getJobs = createAsyncThunk(
  "constants/getJobs",
  async (_, thunkAPI) => {
    try {
      const response = await constantsService.getJobs();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
);

export const getSectors = createAsyncThunk(
  "constants/getSectors",
  async (_, thunkAPI) => {
    try {
      const response = await constantsService.getSectors();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
);

export const getLanguages = createAsyncThunk(
  "constants/getLanguages",
  async (_, thunkAPI) => {
    try {
      const response = await constantsService.getLanguages();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
); 

export const getRegions = createAsyncThunk(
  "constants/getRegions",
  async (_, thunkAPI) => {
    try {
      const response = await regionService.getRegions();
      return response.data.regions;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
);